<template>
  <b-dropdown
    class="add-field-dd"
    menu-class="menu-shadow text-medium field-list-menu"
    toggle-class="dd-field border-0 flex-center text-brand text-medium pointer"
    toggle-tag="span"
    boundary="viewport"
    text="+ Filter"
    no-caret
  >
    <b-dropdown-header id="dropdown-header-label">
      <b>Add Filter</b>
    </b-dropdown-header>
    <b-dropdown-item
      v-for="field in options.systemFields"
      :key="field.id"
      @click="$emit('select', field)"
    >
      {{ field.label }}
    </b-dropdown-item>
    <b-dropdown-divider v-if="options.customFields.length > 0" />
    <b-dropdown-group
      id="dropdown-group-1"
      header="Custom fields"
      v-if="options.customFields.length > 0"
    >
      <custom-field-filter-option
        v-for="field in options.customFields"
        :key="field.id"
        :field="field"
        :org-id="orgId"
        @select="$emit('select', field)"
      />
    </b-dropdown-group>
    <b-dropdown-divider v-if="options.nql" />
    <b-dropdown-item :key="options.nql.id" @click="$emit('select', options.nql)" v-if="options.nql">
      Add NQL
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import CustomFieldFilterOption from '@/components/initiative/filter/CustomFieldFilterOption.vue'
import {
  BDropdown,
  BDropdownDivider,
  BDropdownGroup,
  BDropdownHeader,
  BDropdownItem
} from 'bootstrap-vue'

/**
 * This dropdown contains the list of initiative fields that can be added as filter.
 * This lists the system fields as well as custom fields
 */
export default {
  name: 'AddFilterFieldDropdown',
  props: ['fields', 'orgId'],
  components: {
    CustomFieldFilterOption,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BDropdownGroup,
    BDropdownHeader
  },
  data() {
    return {}
  },
  computed: {
    options() {
      const customFields = this.fields.filter(field => field.fieldType === 'custom_field')
      const systemFields = this.fields.filter(field => field.fieldType === 'system_field')
      const nql = this.fields.find(field => field.fieldType === 'nql')
      return {
        systemFields,
        customFields,
        nql
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

/deep/ .dd-field,
/deep/ .dd-field:active {
  background-color: $documentColor !important;
  padding: 0;

  &:focus {
    box-shadow: none;
  }
}

/deep/ .text-brand {
  color: $brand !important;
}

/deep/ .field-list-menu {
  @include scrollbarWidth($scrollSecondary);

  max-height: 60vh;
  overflow: auto;
}
</style>
